import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { createMetaManager } from 'vue-meta';
import '@/styles/base.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faClock, faHandshake, faQuestionCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import {
  faArrowLeft,
  faCheckCircle,
  faCircle,
  faCog,
  faDownload,
  faEllipsisV,
  faExclamationCircle,
  faExternalLinkAlt,
  faLanguage,
  faMicrophone,
  faPaperclip,
  faSquare,
  faTimes,
  faUpload,
  faVideo,
  faVideoSlash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import i18n from './i18n';

library.add(
  faCheckCircle,
  faQuestionCircle,
  faVideo,
  faTimes,
  faUpload,
  faTimesCircle,
  faMicrophone,
  faLanguage,
  faCog,
  faCircle,
  faSquare,
  faEllipsisV,
  faPaperclip,
  faClock,
  faVideoSlash,
  faExternalLinkAlt,
  faHandshake,
  faDownload,
  faExclamationCircle,
  faArrowLeft,
);

const app = createApp(App)
  .use(store)
  .use(router)
  .use(createMetaManager())
  .component('font-awesome-icon', FontAwesomeIcon);

app.use(i18n);

app.mount('#app');
